import { render, staticRenderFns } from "./ConcernElementsSection.vue?vue&type=template&id=7f5e4f1c&"
import script from "./ConcernElementsSection.vue?vue&type=script&lang=js&"
export * from "./ConcernElementsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports